// Libs
import React, { useState, useContext } from "react";
import { StoresContext, Stores } from "Globals/Stores";
import { useObserver } from "@shoothill/core";
import { Box } from "@material-ui/core";

// App
import PropertyDetailsViewModel from "Globals/ViewModels/FormSections/PropertyDetails/PropertyDetailsViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import PersonViewModel from "Globals/ViewModels/Shared/PersonViewModel";
import { PersonForm, PersonTable } from "./Components";

// Components

interface IProps {
    propertyDetailsViewModel: PropertyDetailsViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const PersonalDetailsFormView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [viewModel] = useState(() => new PersonViewModel());

    return useObserver(() => (
        <Box style={{ backgroundColor: "#F0F0F0", padding: "15px" }}>
            {!props.applicationFormViewModel.model.isSubmitted && (
                <PersonForm
                    viewModel={viewModel}
                    propertyDetailsViewModel={props.propertyDetailsViewModel}
                    applicationFormViewModel={props.applicationFormViewModel}
                    storesContext={storesContext}
                />
            )}

            {props.propertyDetailsViewModel.getSortedPersonViewModels.length > 0 && (
                <PersonTable
                    personViewModels={props.propertyDetailsViewModel.getSortedPersonViewModels}
                    propertyDetailsViewModel={props.propertyDetailsViewModel}
                    applicationFormViewModel={props.applicationFormViewModel}
                    storesContext={storesContext}
                />
            )}
        </Box>
    ));
};
